export default __webpack_public_path__ + "static/media/Resume4-page-001.629b6372.jpg";